<template>
  <div class="container-fluid text-white position-relative overflow-hidden py-5" id="video-fitbar">
    <!-- Bowl Decorativo Flotante Disperso (Sirloin & Puré) -->
    <div class="floating-bowl-decor bowl-video d-none d-lg-block">
      <img
        :src="require('@/assets/img/NEW Delivery_1.png')"
        alt="Sirloin & Puré"
        class="img-fluid floating-bowl-img"
      />
    </div>

    <div class="row align-items-center">
      <!-- Ilustración de Verduras Izquierda -->
      <div class="col-xl-3 d-none d-xl-block text-start p-0">
        <img
          class="img-fluid verduras-img"
          :src="require('@/assets/img/verduras_IZQ.png')"
          alt="Verduras Fitbar Izquierda"
        />
      </div>

      <!-- Contenido Central y Video -->
      <div class="col-12 col-xl-6 text-center px-3 px-md-4">
        <p class="quicksand lead text-white fw-semibold mb-2">
          En nuestro menú tenemos deliciosos y balanceados opciones para mantenerte saludable.
        </p>

        <p class="quicksand text-white text-opacity-75 mb-3">
          Somos un restaurante de comida para personas que cuidan su alimentación y tienen un estilo de vida fitness.
        </p>

        <p class="roboto fw-bold text-white fs-4 mb-4 text-uppercase letter-spacing-1">
          ¡REALIZA TU PEDIDO!
        </p>

        <div class="video-container mx-auto shadow-2xl rounded-4 overflow-hidden">
          <div class="ratio ratio-16x9">
            <iframe
              src="https://www.youtube.com/embed/pd9ePJJvY5I?rel=0&controls=1"
              title="Conoce The Fit Bar Cancún"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>

      <!-- Ilustración de Verduras Derecha -->
      <div class="col-xl-3 d-none d-xl-block text-end p-0">
        <img
          class="img-fluid verduras-img"
          :src="require('@/assets/img/verduras_DER.png')"
          alt="Verduras Fitbar Derecha"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoSection",
};
</script>

<style scoped>
#video-fitbar {
      text-align: center;
    background: /* Capa de difuminado horizontal que elimina el corte y se funde suavemente con el fondo oscuro */ linear-gradient(to right, transparent 0%, transparent 40%, rgba(21, 24, 25, 0.3) 60%, rgb(21 24 25 / 90%) 85%, #151819 100%), /* Resplandor cálido de brasa */ radial-gradient(circle at 75% 50%, rgb(253 111 60) 0%, rgba(230, 85, 35, 0.06) 45%, #942700 72%), /* Degradado cálido base */ linear-gradient(206deg, #fbad01e3 0%, #dc3545db 60%, #121415 100%);
}

.verduras-img {
  max-height: 480px;
  object-fit: contain;
}

.letter-spacing-1 {
  letter-spacing: 1.5px;
}

.video-container {
  max-width: 580px;
  background: #000;
  border: 4px solid rgba(255, 255, 255, 0.25);
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.25);
}

/* Bowl Decorativo Flotante Disperso (Sirloin & Puré) */
.floating-bowl-decor {
  position: absolute;
  z-index: 5;
  pointer-events: none;
  filter: drop-shadow(0 15px 25px rgba(0, 0, 0, 0.5));
}

.bowl-video {
  bottom: 35px;
  right: clamp(25px, 6vw, 100px);
  animation: floatBowlVideo 6.5s ease-in-out infinite alternate;
}

.floating-bowl-img {
  width: 215px;
  height: 215px;
  object-fit: contain;
  transform: rotate(-8deg);
  transition: transform 0.3s ease;
}

.bowl-label-mini {
  background: rgba(15, 18, 20, 0.9);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 3px 12px;
  border-radius: 20px;
  text-align: center;
  margin-top: -8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  white-space: nowrap;
}

@keyframes floatBowlVideo {
  0% { transform: translateY(0) rotate(0deg); }
  100% { transform: translateY(-16px) rotate(-4deg); }
}
</style>
